import React from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import { injectIntl, intlShape } from 'react-intl';
import { withRouter } from 'react-router-dom';
import config from '../../config';
import {
  getTextContainerClassName,
  getWrapperClassName,
  getHeight,
  routeMatch,
  goToSignUp,
  goToPlans,
  getTopOffset,
  shouldHidePagesBanner,
  shouldBindEvent,
} from '../../utils/conversion-banner-utils';
import ConversionBannerText from './ConversionBannerText';
import ConversionBannerLink from './ConversionBannerLink';
import messages from './messages';

class ConversionBanner extends React.PureComponent {
  binded = false;

  static propTypes = {
    intl: intlShape.isRequired,
    isAuthenticated: PropTypes.bool,
    playSubscripton: PropTypes.string,
  };

  static defaultProps = {
    isAuthenticated: false,
    playSubscripton: '',
  };

  state = {
    isFixed: false,
  };

  componentDidMount() {
    const { location, playSubscripton, isAuthenticated } = this.props;

    if (shouldBindEvent(location.pathname, playSubscripton, isAuthenticated)) {
      this.bindHandleScroll();
    }
  }

  componentDidUpdate() {
    const { location, playSubscripton, isAuthenticated } = this.props;
    if (shouldBindEvent(location.pathname, playSubscripton, isAuthenticated) && !this.binded) {
      this.bindHandleScroll();
    } else if (
      !shouldBindEvent(location.pathname, playSubscripton, isAuthenticated) &&
      this.binded
    ) {
      this.unBindHandleScroll();
    }
  }

  componentWillUnmount() {
    if (this.binded) {
      this.unBindHandleScroll();
    }
  }

  bindHandleScroll = () => {
    window.addEventListener('scroll', this.handleScroll);

    this.binded = true;
  };

  unBindHandleScroll = () => {
    window.removeEventListener('scroll', this.handleScroll);

    this.binded = false;
  };

  handleScroll = () => {
    const { location, isAuthenticated, playSubscripton } = this.props;
    const windowY = window.pageYOffset;
    const topOffset = getTopOffset(location.pathname, isAuthenticated, playSubscripton);
    const routeMatched = routeMatch(location.pathname);
    const { isFixed } = this.state;

    if (topOffset === 0 && !isFixed && !routeMatched && playSubscripton === 'active') {
      this.setState({ isFixed: true });
    } else if (topOffset === 0 && isFixed && !routeMatched && playSubscripton === 'active') {
      return;
    }

    if (windowY > topOffset && !isFixed) {
      this.setState({ isFixed: true });
    } else if ((windowY < topOffset && isFixed) || (windowY === 0 && isFixed)) {
      this.setState({ isFixed: false });
    }
  };

  renderBanner = matches => {
    const { intl, location, isAuthenticated } = this.props;
    const { isFixed } = this.state;
    const { formatMessage } = intl;

    if (!routeMatch(location.pathname) || isAuthenticated) {
      return null;
    }

    const isFixedMatches = isFixed && matches;
    const wrapperClassName = getWrapperClassName(matches, isFixed);
    const textContainerClassName = getTextContainerClassName(isFixedMatches);
    const height = getHeight(isFixed, matches);

    return (
      <div style={{ height }} onClick={goToSignUp} data-id="conversion-banner">
        <div style={{ top: 64 }} className={wrapperClassName}>
          <div className={textContainerClassName}>
            <ConversionBannerText
              isFixedMatches={isFixedMatches}
              message={formatMessage(messages.off)}
            />
            <div className="ph3-ns">
              <ConversionBannerLink
                isFixedMatches={isFixedMatches}
                message={formatMessage(messages.button)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderPagesBanner = (isLarge, isMedium) => {
    const { isAuthenticated, location, playSubscripton } = this.props;
    const { formatMessage } = this.props.intl;
    const { isFixed } = this.state;
    const conditions = {
      subscription: playSubscripton,
      isAuthenticated,
      pathname: location.pathname,
      isFixed,
      isLarge,
    };

    if (shouldHidePagesBanner(conditions)) {
      return null;
    }

    let buttonMsg = '';
    let onClickAction = null;

    if (!isAuthenticated || (isAuthenticated && playSubscripton === 'pending')) {
      buttonMsg = formatMessage(messages.button);
      onClickAction = goToSignUp;
    } else if (isAuthenticated && playSubscripton === 'cancelled') {
      buttonMsg = formatMessage(messages.cancelled);
      onClickAction = goToPlans;
    }

    const isAuthFixed = isAuthenticated && isFixed;
    const top = isAuthFixed ? 60 : 64;
    const wrapperStyle = isAuthFixed ? { height: isMedium ? 97 : 62 } : null;

    return (
      <div data-id="conversion-banner" onClick={onClickAction} style={wrapperStyle}>
        <div style={{ top }} className="bg-black w-100 pa3 fixed z-5">
          <div className="flex flex-column items-center justify-center tc white futura-heavy">
            <div className="f5 mb2 lh-title dn db-m">{formatMessage(messages.off)}</div>
            <a
              href="https://www.fender.com/connect/sign-up?ref=https://www.fender.com/play/plans"
              className="link dib br2 ttu bg-red futura-heavy lh-solid white f6-m ph3-m pa2 f8 ba bn-m b--dark-red"
            >
              {buttonMsg}
            </a>
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <>
        <Media query={config.breakpoints.small}>{this.renderBanner}</Media>
        <Media query={config.breakpoints.large}>
          {matches => (matches ? this.renderPagesBanner(true, false, false) : null)}
        </Media>
        <Media query={config.breakpoints.medium}>
          {matches => (matches ? this.renderPagesBanner(false, true, false) : null)}
        </Media>
        <Media query={config.breakpoints.small}>
          {matches => (matches ? this.renderPagesBanner(false, false, true) : null)}
        </Media>
      </>
    );
  }
}

export default injectIntl(withRouter(ConversionBanner));
